import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-home',
  standalone: false,
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  // Featured Menu Items
  featuredMenus2 = [
    {
      title: 'Classic Fish & Chips',
      description:
        'Golden crispy battered fish served with fluffy chips and a side of tartar sauce.',
      image: '/images/featured-1.png',
      // link: '/menu/fish-and-chips',
      // ctaText: 'Order Now',
      // ctaLink: '/menu',
      // tag: 'Popular',
    },
    {
      title: 'Juicy Chicken & Kebab Meals',
      description:
        'Savor our grilled kebabs and crispy fried chicken, packed with flavor.',
      image: '/images/featured-2.jpg',
      // link: '/menu/chicken-kebab',
      // ctaText: 'Order Now',
      // ctaLink: '/menu',
      // tag: 'New',
    },
    {
      title: 'Tasty Burgers & Wraps',
      description:
        'Freshly made burgers and wraps, filled with quality ingredients and big taste.',
      image: '/images/featured-3.png',
      // link: '/menu/burgers-wraps',
      // ctaText: 'Order Now',
      // ctaLink: '/menu',
      // tag: 'Popular',
    },
  ];
  featuredMenus = [
    {
      title: 'Classic Fish & Chips',
      description:
        'Golden crispy battered fish served with fluffy chips and a side of tartar sauce.',
      image: '/images/featured-1.png',
      link: '/menu/fish-and-chips',
      ctaText: 'Order Now',
      ctaLink: '/menu',
      tag: 'Popular',
    },
    {
      title: 'Juicy Chicken & Kebab Meals',
      description:
        'Savor our grilled kebabs and crispy fried chicken, packed with flavor.',
      image: '/images/featured-2.jpg',
      link: '/menu/chicken-kebab',
      ctaText: 'Order Now',
      ctaLink: '/menu',
      tag: 'New',
    },
    {
      title: 'Tasty Burgers & Wraps',
      description:
        'Freshly made burgers and wraps, filled with quality ingredients and big taste.',
      image: '/images/featured-3.png',
      link: '/menu/burgers-wraps',
      ctaText: 'Order Now',
      ctaLink: '/menu',
      tag: 'Popular',
    },
  ];

  // Why Choose Us Section
  whyChooseUs = [
    {
      title: 'Fresh Ingredients',
      description:
        'We use only the freshest ingredients to ensure top quality in every bite.',
      image: '/images/fresh.png',
    },
    {
      title: 'Fast Delivery',
      description:
        'Your order is prepared and delivered quickly, keeping it fresh and hot.',
      image: '/images/delivery.png',
    },
    {
      title: 'Great Prices',
      description: 'Delicious food at prices that won’t break the bank.',
      image: '/images/price.png',
    },
  ];

  // How It Works Section
  howItWorks = [
    {
      number: '1',
      title: 'Choose Your Meal',
      description: 'Browse our menu and pick your favorites.',
    },
    {
      number: '2',
      title: 'Place Your Order',
      description: 'Add items to your cart and checkout easily.',
    },
    {
      number: '3',
      title: 'Enjoy Your Food',
      description: 'We deliver fast, so you can enjoy fresh food at home.',
    },
  ];

  // Google Business Reviews (Dummy Data)
  googleReviews = [
    {
      name: 'John Doe',
      rating: 5,
      comment: 'Amazing food and fast delivery! Will order again.',
      profilePic: '/images/user-1.jpg',
    },
    {
      name: 'Sarah Smith',
      rating: 4,
      comment:
        'Great taste and quality, but delivery took a bit longer than expected.',
      profilePic: '/images/user-2.jpg',
    },
    {
      name: 'Michael Johnson',
      rating: 5,
      comment: 'Absolutely loved the fish & chips! Best in town.',
      profilePic: '/images/user-3.jpg',
    },
  ];
}
